export enum QueryKeys {
  GET_ORGANIZATIONS = 'GET_ORGANIZATIONS',
  GET_USE_ORGANIZATIONS = 'GET_USE_ORGANIZATIONS',
  GET_ROLES = 'GET_ROLES',
  GET_ROLE_BY_ID = 'GET_ROLE_BY_ID',
  GET_SERVICES = 'GET_SERVICES',
  GET_SERVICE_OPTIONS = 'GET_SERVICE_OPTIONS',
  GET_USERS = 'GET_USERS',
  GET_PERMISSIONS = 'GET_PERMISSIONS',
  GET_PROVINCES = 'GET_PROVINCES',
  GET_REQUESTS = 'GET_REQUESTS',
  GET_CHAT_REQUESTS = 'GET_CHAT_REQUESTS',
  GET_REPORTED_ABUSE = 'GET_REPORTED_ABUSE',
  GET_CHATS_HISTORY = 'GET_CHATS_HISTORY',
  GET_CHAT_ROOMS = 'GET_CHAT_ROOMS',
  GET_CHAT_ROOMS_INFINITE = 'GET_CHAT_ROOMS_INFINITE',
  GET_RESOURCES = 'GET_RESOURCES',
  GET_RESOURCE_CATEGORIES = 'GET_RESOURCE_CATEGORIES',
  GET_DASHBOARD_STATISTICS = 'GET_DASHBOARD_STATISTICS',
  GET_LOCATION_STATISTICS = 'GET_LOCATION_STATISTICS',
  GET_REQUESTS_PER_MONTH = 'GET_REQUESTS_PER_MONTH',
  GET_REQUESTS_PER_CATEGORY = 'GET_REQUESTS_PER_CATEGORY',
  ORGANIZATION_STATS = 'ORGANIZATION_STATS',
  GET_TRANSFERED_REQUESTS = 'GET_TRANSFERED_REQUESTS',
  GET_REQUESTS_COUNT_PER_STATUS = 'GET_REQUESTS_COUNT_PER_STATUS',
  GET_APP_CONTENT = 'GET_APP_CONTENT',
  GET_ORGANIZATION_OPTIONS = 'GET_ORGANIZATION_OPTIONS',
  GET_REQUEST_BY_ID = 'GET_REQUEST_BY_ID',
  GET_REQUEST_COMMENTS = 'GET_REQUEST_COMMENTS',
  GET_REPORTED_ABUSE_COUNT_BY_GENDER = 'GET_REPORTED_ABUSE_COUNT_BY_GENDER',
  GET_SERVICES_COUNT_BY_STATUS = 'GET_SERVICES_COUNT_BY_STATUS',
}
